<template>
  <div id="timesheet-commissions">
    <SimplePageHeader title="Consultants"></SimplePageHeader>
    <v-container fluid class="px-0 pt-2 mt-4">
      <v-layout column>
        <v-data-table
          class="mb-3"
          dense
          :headers="headers"
          :items="assignmentGrossProfitItems"
          :items-per-page="5"
        >
          <template v-slot:item.timeSheetHours="{ item }">
            {{ item.timeSheetHours | formatDecimal }}
          </template>
          <template v-slot:item.employeeRole="{ item }">
            {{ item.employeeRole | roleLabel }}
          </template>
          <template v-slot:item.workedHours="{ item }">
            {{ item.payRateTypeId === HOURLY_PAID || item.billRateTypeId === HOURLY_BILLED ? item.workedHours : 'N/A' }}
          </template>
          <template v-slot:item.monthlyTotalGrossProfit="{ item }">
            {{ item.monthlyTotalGrossProfit | currency }}
          </template>
          <template v-slot:item.commissionPercent="{ item }">
            {{ item.commissionPercent | percent }}
          </template>
          <template v-slot:item.monthlyIndividualGrossProfit="{ item }">
            {{ item.monthlyIndividualGrossProfit | currency }}
          </template>
          <template v-slot:item.contractorCommissionGrossProfit="{ item }">
            {{ item.contractorCommissionGrossProfit | currency }}
          </template>
          <template v-slot:item.actions="{ item }">
            <v-btn
              class="mx-1 my-1 hide-on-print"
              color="primary"
              outlined
              @click.prevent="handleShowAssignmentDetails($event, item)"
            >
              <v-icon color="primary">badge</v-icon>
            </v-btn>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="mx-1 my-1 hide-on-print"
                  color="primary"
                  outlined
                  v-bind="attrs"
                  v-on="on"
                  @click.prevent="handleClickViewTimeCard($event, item)"
                >
                  <v-icon color="primary">schedule</v-icon>
                </v-btn>
              </template>
              <span>Go to time card</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { SimplePageHeader } from '@/components/pageComponents'
import { assignmentEditRoute, timeCardReportRoute } from '@/lib/constants/routes'
import { HOURLY as HOURLY_PAID } from '@/lib/constants/payRateTypes'
import { HOURLY as HOURLY_BILLED } from '@/lib/constants/billRateTypes'

export default {
  components: {
    SimplePageHeader
  },
  props: [
    'assignmentGrossProfitItems',
    'month',
    'year'
  ],
  data () {
    return {
      HOURLY_PAID,
      HOURLY_BILLED,
      assignmentId: null,
      headers: [
        { text: 'Client', value: 'clientName', class: 'pl-4 pr-0', width: '15%' },
        { text: 'Consultant', value: 'consultantName', class: 'pl-4 pr-0', width: '15%' },
        { text: 'Billable Hours', value: 'timeSheetHours', class: 'pl-4 pr-0', cellClass: 'pl-4', width: '10%' },
        { text: 'Contractor Commission GP', value: 'contractorCommissionGrossProfit', class: 'pl-2 pr-0', cellClass: 'pl-2', width: '15%' },
        { text: 'Role', value: 'employeeRole', class: 'pr-0', width: '10%' },
        { text: 'Total GP', value: 'monthlyTotalGrossProfit', class: 'hide-on-sm px-0', cellClass: 'hide-on-sm px-0', width: '10%' },
        { text: 'Commission %', value: 'commissionPercent', class: 'pl-2 pr-0', cellClass: 'pl-2', width: '10%' },
        { text: 'Individual GP', value: 'monthlyIndividualGrossProfit', class: 'pl-2 pr-0', cellClass: 'pl-2', width: '10%' },
        { text: 'Actions', value: 'actions', class: 'hide-on-print px-0', cellClass: 'hide-on-print', align: 'center', width: '12%', sortable: false }
      ]
    }
  },
  methods: {
    handleShowAssignmentDetails (event, item) {
      this.assignmentId = item.assignmentId
      const routeData = this.$router.resolve({
        name: assignmentEditRoute.name,
        params: { id: this.assignmentId }
      })
      if (event.ctrlKey === true) {
        window.open(routeData.href, '_blank')
      } else {
        window.open(routeData.href, '_self')
      }
    },
    handleClickViewTimeCard (event, item) {
      if (!this.year || !this.month) return
      const year = parseInt(this.year)
      const month = parseInt(this.month)
      const lastDay = new Date(year, month, 0).getDate()
      const pad = (n) => String(n).padStart(2, '0')
      const startDate = `${year}-${pad(month)}-01T00:00:00`
      const endDate = `${year}-${pad(month)}-${pad(lastDay)}T23:59:59`
      const routeData = this.$router.resolve({
        name: timeCardReportRoute.name,
        query: { startDate, endDate, assignmentId: item.assignmentId }
      })
      if (event.ctrlKey === true) {
        window.open(routeData.href, '_blank')
      } else {
        window.open(routeData.href, '_self')
      }
    }
  }
}
</script>
